export default __webpack_public_path__ + "_/images/gifts-icon-c9bd7bc742ad6e562ccdc478d744bbba34a671b071449dc0ca0913f954fa7cff.png";